import _defineProperty from "/app/src/Web/InternetBranch/node_modules/@babel/runtime-corejs2/helpers/esm/defineProperty.js";
/* eslint-disable */
export default {
  warn: {
    required: '{title} bilgisini gereklidir'
  },
  formItem: {
    title: 'Form Bileşeni Güncelleme',
    documentType: 'Doküman Türü',
    smalltextfieldLabelLabel: 'Etiket',
    smalltextfieldLabelPalceholder: 'Etiket Giriniz',
    smalltextfieldPlaceholderLabel: 'Açıklama',
    smalltextfieldPlaceholderPalceholder: 'Açıklama Giriniz',
    smalltextfieldIsRequired: 'Zorunlu',
    customerLabelLabel: 'Etiket',
    customerLabelPalceholder: 'Etiket Giriniz',
    customerPlaceholderLabel: 'Açıklama',
    customerPlaceholderPalceholder: 'Açıklama Giriniz',
    customerIsRequired: 'Zorunlu',
    largetextariaLabelLabel: 'Etiket',
    largetextariaLabelPalceholder: 'Etiket Giriniz',
    largetextariaRowsLabel: 'Satır Sayısı',
    largetextariaRowsPalceholder: 'Satır Satır Sayısı Giriniz',
    largetextariaIsRequired: 'Zorunlu',
    dropdownlistLabelLabel: 'Etiket',
    dropdownlistLabelPalceholder: 'Etiket Giriniz',
    dropdownlistOptionsStringLabel: 'Seçenekler',
    dropdownlistOptionsStringPalceholder: 'Seçenekleri Aralarında | Olacak Şekilde Giriniz',
    dropdownlistIsRequired: 'Zorunlu',
    checklistLabelLabel: 'Etiket',
    checklistLabelPalceholder: 'Etiket Giriniz',
    checklistOptionsStringLabel: 'Seçenekler',
    checklistOptionsStringPalceholder: 'Seçenekleri Aralarında | Olacak Şekilde Giriniz',
    checklistIsRequired: 'Zorunlu',
    radiobuttonsLabelLabel: 'Etiket',
    radiobuttonsLabelPalceholder: 'Etiket Giriniz',
    radiobuttonsOptionsStringLabel: 'Seçenekler',
    radiobuttonsOptionsStringPalceholder: 'Seçenekleri Aralarında | Olacak Şekilde Giriniz',
    radiobuttonsIsRequired: 'Zorunlu',
    dateLabelLabel: 'Etiket',
    dateLabelPlaceholder: 'Etiket Giriniz',
    datePlaceholderLabel: 'Açıklama',
    datePlaceholderPlaceholder: 'Açıklama Giriniz',
    dateIsRequired: 'Zorunlu',
    deleteQuestion: 'Form elemanını silmek istediğinize emin misiniz?',
    formfieldfieldCols: 'Genişlik',
    formfieldColsPlaceholder: 'Genişlik Giriniz',
    requiredLabel: 'Etiket giriniz',
    lengthLabel: 'Etiket 2 ile 250 karakter arasında olmalıdır',
    requiredPlaceholder: 'Açıklama giriniz',
    lengthPlaceholder: 'Açıklama 2 ile 250 karakter arasında olmalıdır',
    requiredCols: 'Genişlik giriniz',
    requiredRows: 'Satır sayısı giriniz',
    requiredOptionsString: 'Seçenekleri giriniz',
    lengthOptionsString: 'Seçenekler 2 ile 2500 karaketer arasında olmalıdır',
    eventHook: 'Olay Kancası',
    eventHookPalceholder: 'Atama yapılacak olay değişkeni adı',
    requiredAlias: 'Süreç değişkeni seçiniz',
    aliasPartyId: 'Muhatap Numarası',
    aliasProductId: 'Ürün Kimlik No'
  },
  deadline: {
    description: 'Bu adımın gerçekleşmesi için uygun zaman nedir?',
    thisStep: 'Bu adımı',
    stepOptionPlaceholder: 'Adım seçenekleri',
    timeDeadlineOptionPlaceholder: 'Seçenek',
    timeUnitPlaceholder: 'Birim',
    timeValue: 'Süre',
    done: 'içinde tamamla',
    startOfProcess: 'Sürecin başlamasından',
    endOfLastProcess: 'Sürecin son adımı',
    after: 'sonra',
    before: 'önce',
    minutes: 'dakika',
    hours: 'saat',
    days: 'gün',
    weeks: 'hafta',
    months: 'ay'
  },
  newprocess: {
    newprocessTitle: ' Süreçi Oluştur',
    newprocessSubTitle: 'Yeni süreç bilgilerini girerek ön izleme ve süreç başlatma yapabilirsiniz.',
    titleLabel: 'Süreç Başlığı',
    titlePlaceholder: 'Süreç Başlığı Giriniz',
    titleRequired: 'Süreç başlığını giriniz',
    titleLength: 'Süreç başlığı 5 ile 250 karakter arasında olmalıdır',
    buttonSavenewprocess: 'Kayıt',
    loadSummaryError: 'Süreç şablonu bilgileri yüklenemedi.',
    createSuccessMessage: 'Başarılı!',
    createSuccessContinue: 'Şablon oluşturma işlemi başarılı bir şekilde gerçekleşti. Süreçe yönlendirileceksiniz.',
    formItemsTitle: 'Form Alanları',
    formItemTitle: 'Başlık',
    formItemGroupName: 'Atanan',
    formItemDeadline: 'Son Tarih',
    required: 'Zorunlu'
  },
  processListItem: {
    next: 'Saradaki',
    Owner: 'Başlattığım süreç',
    Wait: 'Görev bekleyen süreç',
    Pass: 'Görevi tamamladığım süreç',
    Issue: 'Sorun olan süreç',
    All: 'Hepsi',
    owner: 'Süreci Başlatan',
    status: 'Sürecin Durumu',
    completed: 'Tamamlanan'
  },
  task: {
    newCommentLabel: 'Süreçi İzleyen Herkesin Gerebildiği Bir Mesajı Bırakın',
    newCommentPlaceholder: 'Mesajınızı giriniz',
    newCommenmtButton: 'Mesaj Ekle',
    deletefile: '{filename} dosyasını silmek istediğinize emin misiniz？',
    started: 'Görevin atandığı tarih ve saat',
    taskdeadline: 'Görevin tamamlanması gereken tarih ve saat',
    assignment: 'Görevin atandığı kullanıcı',
    completed: 'Tamamlandı',
    open: 'Açık',
    deadline: 'Süresi Geçti',
    status: 'Görevin Durumu',
    messageCount: 'Göreve yapılan yorum sayısı',
    required: '{title} giriniz',
    minmax: 'Değer {min} - {max} aralığında olmalıdır'
  },
  settings: {
    description: 'Süreç için genel ayarlar',
    isMandatory: 'Bu görev tek bir çalışana atananır',
    isRenewable: 'Tekrar açılabilir',
    canChange: 'Bitiş tarihi değiştirilebilir',
    kpiCode: 'TPG Kodu',
    pageLink: 'İşlem Sayfası',
    performanceReviewItemTypeId: 'Performans Kategorisi',
    totalAmountAllowed: 'İzin Verilen Toplam Tutar',
    totalMinuteAllowed: 'İzin Verilen Toplam Süre',
    estimatedMinute: 'Tahmini Süre',
    taskType: 'Görev Türü',
    taskHeaderType: 'Görev Ekranı Başlığı',
    inventoryItemTypeId: 'Sarf Malzemesi Türü',
    quantity: 'Adet',
    actions: 'İşlemler',
    formTitle: 'İşin Yapılması İçin Kullanılan Envanter',
    inventoryItemTypeIdPlaceholder: 'Sarf Malzemesi Seçiniz',
    new: 'Yeni Ekle',
    edit: 'Düzenle',
    individual: 'Bağımsız',
    sequential: 'Sıralı',
    none: 'Yok',
    customerreview: 'Müşteri Özeti',
    delete: 'Sil',
    deleteLabel: 'Kullanılan SArf Malzemesi Silme Onayı',
    deleteQuestion: 'Görev için gerekli olan sarf malzemesinin silinmesini onaylıyor musunuz?',
    performanceReviewItemContextVariableName: 'Performans Sayacı Context Değişkeni',
    performanceTab: 'Performans',
    inventoryTab: 'Sarf Malzemesi',
    eventTab: 'Olay',
    formPerformanceTitle: 'Performans Kategorisi ',
    eventName: 'Olay',
    formEventTitle: 'Olay ',
    EventProperty: 'Olay Parametre Değeri',
    ContextValue: 'Süreç Değişkeni'
  },
  templateList: {
    createButtonText: 'Şablon Oluştur',
    startProcessButtonText: 'Süreç Başlat',
    codetitle: 'İş Ailesi',
    title: 'Şablon',
    description: 'Açıklama',
    actions: 'İşlemler',
    archives: 'Arşivler',
    actives: 'Aktifler',
    none: 'Yok',
    stepCount: 'Adım Sayısı',
    createDate: 'Oluşturulma Tarihi',
    isActive: 'Aktif',
    processCount: 'Toplam Süreç Sayısı',
    templateCount: 'Toplam Süreç Sayısı',
    template: 'Şablon',
    process: 'Süreç',
    count: 'Çalışma Sayısı',
    monthlyCount: 'Aylık Çalışma Sayısı',
    totalRunCount: 'Şablondan üretilen süreç sayısı',
    customer: 'Müşteri',
    event: 'Olay',
    organization: 'Operasyon',
    employee: 'Çalışan'
  },
  tasklist: {
    comments: 'Yorumlar',
    commentTooltip: 'Yorumları görmek için tıklayınız',
    cancel: "Çıkış",
    searchText: 'Arama...',
    filter: 'Filtre',
    pageTitle: 'Atanmış Görev Listesi',
    pageDescription: 'Şirket içerisindeki atanmış görevlerin listesi. Size ait olanlar yeşil renk ile gösterilmektedir.',
    perpage: 'Sayfa başına',
    hide: 'Gizle',
    show: 'Göster',
    detail: 'Detaylar',
    complete: 'Tamamla',
    task: 'Görev',
    isActive: 'Aktif Mi',
    progress: 'Görev Durumu',
    owner: 'Oluşturan',
    createDate: 'Tarih',
    actions: 'İşlemler',
    name: 'Ad Soyad',
    info: 'Süreç detaylarını görmek için tıklayınız.'
  },
  processlist: {
    searchText: 'Arama...',
    filter: 'Filtre',
    pageTitle: 'Aktif Süreç Listesi',
    pageDescription: 'Sizin başlattığınız veya size atanan süreçlerin listesini görüntüler.',
    processCategory: 'İş Ailesi',
    errorMessage: 'Aktif süreçler alınamadı.',
    status: 'Durum',
    process: 'Süreç',
    startedBy: 'Başlatan Kişi',
    nextTask: 'Sıradaki Görev',
    progression: 'İlerleme',
    actions: 'İşlemler',
    refresh: 'Yenile',
    statusChart: 'Aktif Süreçlerin Durum Dağılımı'
  },
  template: {
    createTemplateTitle: 'Yeni Şablon Oluştur',
    createTemplateSubTitle: 'İş süreci tanımı için yeni şablon oluşturunuz.',
    updateTemplateTitle: 'Şablon Güncelleme',
    updateTemplateSubTitle: 'Oluşturduğunuz şablon için güncelleme yapabilirsiniz.',
    titlePlaceholder: 'Şablon Adı Giriniz',
    titleLabel: 'Şablon Adı',
    descriptionPlaceholder: 'Şablon Açıklaması Giriniz',
    descriptionLabel: 'Şablon Açıklaması',
    codePlaceholder: 'Süreç Sınıfını Seçiniz',
    codeLabel: 'Süreç Sınıfı',
    buttonSaveTemplate: 'Şablon Kaydet',
    buttonUpdateTemplate: 'Şablon Güncelle',
    processInstructionPlaceholder: 'Süreç Açıklaması giriniz',
    processInstructionLabel: 'Şüreç Açıklaması',
    iconPlaceholder: 'İkon Seçiniz',
    iconLabel: 'İkon',
    createSuccessMessage: 'Başarılı!',
    createSuccessContinue: 'Şablon oluşturma işlemi başarılı bir şekilde gerçekleşti. Detay Bilgiler için yönlendirileceksiniz',
    editSuccessMessage: 'Güncelleme!',
    editSuccessContinue: 'Şablon güncelleme başarılı bir şekilde gerçekleşti.',
    deleteTemplate: 'Sİl',
    cancelTemplate: 'Vazgeç',
    deleteQuestion: 'Süreç şablonunu silmek istediğinize emin misiniz?',
    archiveQuestion: 'Bu şablonu arşive göndermek istediğinize emin misiniz?',
    unarchiveQuestion: 'Bu şablonu aktife taşımak ister misiniz ?',
    errorTemplateCode: 'Organizasyon listesi alınamadı.',
    requiredTitle: 'Şablon adı gereklidir',
    lengthTitle: 'Şablon adı 5 ile 250 karakter arasında olmalıdır',
    requiredDescription: 'Şablon açıklması gereklidir',
    lengthDescription: 'Şablon açıklması 5 ile 500 karakter arasında olmalıdır',
    requiredProcessInstruction: 'Süreç açıklması gereklidir',
    lengthProcessInstruction: 'Süreç açıklaması adı 5 ile 5000 karakter arasında olmalıdır',
    requiredCode: 'Süreç sınıfı gereklidir',
    mainTab: 'Şablon',
    kickoffFormTab: 'Başlangıç Formu',
    event: 'Olay',
    customer: 'Müşteri',
    organization: 'Kurumsal',
    employee: 'Çalışan'
  },
  newStep: {
    titlePlaceholder: 'Adım başlığı giriniz',
    titleLabel: 'Adım Başlığı',
    buttonCreate: 'Süreç Adımı Oluştur',
    requiredTitle: 'Adım başlığı gereklidir',
    lengthTitle: 'Adım başlığı 5 ile 250 karakter arasında olmalıdır'
  },
  step: _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({
    deadline: 'Bitiş: %deadlineTemplateStepId %after %timeCount %timeUnit',
    startOfProcess: 'Sürecin başlamasından',
    step: 'adım',
    formCount: 'Form alanı sayısı',
    open: 'Aç',
    openDescription: 'Süreç adımı editörünü aç',
    assignGroup: 'Atanan ',
    title: 'Süreç Adımı Güncelleme',
    general: 'Süreç Adımı Bilgileri',
    titleLabel: 'Süreç Adımı Başlığı',
    titlePlaceholder: 'Süreç Adımı Başlığı Giriniz',
    detailsLabel: 'Süreç Detayı',
    detailsPlaceholder: 'Süreç Detayı Giriniz',
    form: 'Form',
    assign: 'Atama'
  }, "deadline", 'Bitiş zamanı'), "rules", 'Kurallar'), "advanced", 'Ayarlar'), "deleteQuestion", 'Süreç şablonu adımını silmek istediğinize emin misiniz?'), "requiredTitle", 'Süreç adımı başlığı gereklidir'), "lengthTitle", 'Süreç adımı başlığı 5 ile 250 karakter arasında olmalıdır'), "requiredDetails", 'Süreç adımı detayı gereklidir'), "lengthDetails", 'Süreç adım açıklaması 5 karakterden büyük olmalıdır'),
  newFormItem: {
    typePlaceholder: 'Form elemanını seçiniz',
    typeLabel: 'Form Elemanı',
    saveButton: 'Form Elemanını Ekle',
    smalltextfieldDescription: 'Metin Alanı       (Örn: Telefon, Ad Soyad gibi alanlar için)',
    largetextariaDescription: 'Geniş Metin Alanı (Örn: Açıklama, İptal sebebi, İtiraz sebebi gibi sözel alanlar için)',
    dropdownlistfieldDescription: 'Açılır Liste Seçim(Örn: Ödeme Tipi, Malzeme tipi gibi seçenekler arasında tekli seçim için)',
    checklistDescription: 'Çoklu Seçim       (Örn: Telefon, sms, yüz yüze gibi seçeneklerin bir veya daha fazlasını seçmek için)',
    radiobuttonsDescription: 'Doğrudan Seçim    (Örn: Ödeme Tipi, Malzeme tipi gibi seçenekler arasında tekli seçim için)',
    dateDescription: 'Tarih Seçim       (Örn: Talep tarihi gibi alanlar için)',
    numericDescription: 'Sayı Girişi       (Örn: Talep miktarı gibi alanlar için) ',
    customerDescription: 'Müşteri Seçimi    (Örn: Süreç içinde takip işlemi takip edilecek müşteri seçimi için)',
    employeeDescription: 'Çalışan Seçimi    (Örn: Çalışanın terfi, tayin gibi süreçleri için)',
    fileuploadDescription: 'Dosya Yükeleme    (Örn: Süreç dokümanlarını kayıt etmek için)',
    documentviewerDescription: 'Dosya Görüntüleme (Örn: Onay işlemlerinde dokümanı görüntülemek için)',
    partyidentityinformationDescription: 'Muhatap Kimlik Bilgileri',
    customerproductinformationDescription: 'Müşteri Ürün Bilgileri',
    smalltextfield: 'Metin Alanı',
    largetextaria: 'Geniş Metin Alanı',
    dropdownlistfield: 'Açılır Liste Seçim',
    checklist: 'Çoklu Seçim',
    radiobuttons: 'Doğrudan Seçim',
    customer: 'Müşteri',
    fileupload: 'Dosya Yükleme',
    employee: 'Çalışan Seçim',
    date: 'Tarih',
    numeric: 'Sayısal',
    documentviewer: 'Doküman',
    partyidentityinformation: 'Muhatap Kimlik Bilgileri',
    customerproductinformation: 'Müşteri Ürün Bilgileri'
  },
  assign: {
    getTitleCodesError: 'Görev listesi alınamadı',
    description: 'Bu adım sürecin başında kime atanmalıdır?',
    owner: 'Süreci Başlatan',
    positionPlaceholder: 'Pozisyon seçiniz',
    positionTypePlaceholder: 'Görev Seçiniz',
    assignGroupPlaceDropdownLabel: 'Görev Yeri Seçiniz',
    assignGroupPlaceDropdownPlaceholder: 'Görev Yeri Seçiniz',
    assignOwnerSelectedDesc: 'Bu adım süreci başlatan kişi üzerine atanacaktır.',
    nooptions: 'Organizasyon şeması yüklenemedi',
    position: 'Posizyon',
    positionType: 'Görev',
    robot: 'Robot',
    internalOrganization: 'İş Birimi',
    internalOrganizaitionPlaceholder: 'İş Birimi Seçiniz'
  },
  rule: {
    if: 'Eğer ( ',
    thistask: ') bu adımı',
    step: 'Kriter',
    ruleValue: 'Değer',
    condition: 'Koşul',
    action: 'İşlemler',
    command: 'Lojik',
    description: 'Bu görevi göstermek/gizlemek için kural oluşuturun',
    newRuleButton: 'Yeni Bir Kural Ekle',
    AND: 'Ve',
    OR: 'Veya',
    BracketsAndBrackets: ' ) Ve ( ',
    BracketsOrBrackets: ' ) Veya ( ',
    contains: 'İçeriyorsa',
    notcontains: 'İçermiyorsa',
    equals: 'Eşitse',
    notequals: 'Eşit değilse',
    deleteRuleButton: 'Sil',
    deleteQuestion: 'Görev atama kuralını silmek istediğinize emin misiniz?'
  },
  notifyArchive: {
    archiveNotify: 'Arşiv Onayı',
    archiveWarning: '',
    archiveRemove: 'Arşive Taşı',
    archiveCancel: 'İptal',
    archiveSuccess: 'Arşive taşındı',
    archiveCanceled: 'Taşıma iptal edildi',
    unarchiveNotify: 'Aktif Onayı',
    unarchiveWarning: '',
    unarchiveRemove: 'Aktife Taşı',
    unarchiveCancel: 'İptal',
    unarchiveSuccess: 'Aktive taşındı',
    unarchiveCanceled: 'Taşıma iptal edildi'
  },
  multitask: {
    started: 'En yaşlı görevin atama tarihi',
    deadline: 'En önce süresi dolacak görevin tarihi',
    formItemCount: 'Form verisi sayısı',
    user: 'Atanan kullanıcı',
    processTitle: 'Süreç',
    startedTitle: 'Başlangıç',
    deadlineTitle: 'Bitiş',
    detailsTitle: 'Açıklama',
    statusTitle: 'Durum',
    status_deadline: 'Süresi geçmiş',
    requiredMessage: 'Değer giriniz',
    order: 'Görevin süreçdeki sırası',
    createTask: 'Görev Oluştur',
    freetask: 'Süreç Bağımsız Görev',
    status_open: 'Aktif',
    status_completed: 'Tamamlanmış'
  },
  newtask: _defineProperty(_defineProperty(_defineProperty({
    cancelTask: 'Vazgeç',
    buttonSaveTask: 'Görev Kaydet',
    titleLabel: 'Başlık',
    titlePlaceholder: 'Görev başlığı giriniz',
    descriptionLabel: 'Açıklama',
    descriptionPlaceholder: 'Açıklama giriniz',
    deadline: 'Son Tarih',
    deadlinePlaceholder: 'Son tarihi giriniz',
    requiredTitle: 'Başlğı giriniz',
    lengthTitle: 'Başlık 5 ile 250 karakter arasında olmalıdır',
    requiredDescription: 'Açıklama giriniz',
    lengthDescription: 'Açıklama 5 ile 500 karakter arasında olmalıdır',
    requiredassignTo: 'Atanan kullanıcı seçilmelidir',
    requiredDeadline: 'Son tarihi seçilmelidir',
    tomorrow: 'Yarın',
    twodaylater: 'İki gün sonra',
    treedaylater: 'Üç gün sonra',
    aweeklater: 'Bir hafta sonra',
    twoweeklater: 'İki hafta sonra',
    amonthlater: 'Bir ay sonra',
    assignTo: 'Atama',
    assignToPlaceholder: 'Atama yapılacak kullanıcı seçiniz'
  }, "requiredassignTo", 'Atama yapılacak kullanıcı seçilmelidir'), "createSuccessMessage", 'Başarılı!'), "createSuccessContinue", 'Görev oluşturma işlemi başarılı bir şekilde gerçekleşti. Görev listesine yönlendirileceksiniz.'),
  tooltips: {
    startProcess: 'Süreç Başlat',
    editTemplate: 'Düzenle',
    archive: 'Arşivle',
    deleteTemplate: 'Sil',
    unarchive: 'Arşivden Çıkar',
    viewProcess: 'İncele',
    viewTemplate: 'İncele'
  },
  error: {
    TemplateAlreadyDefinedWithSameTitle: 'Zaten "{title}" ismi ile tanımlı bir süreç bulunmaktadır',
    TemplateStepAlreadyDefinedWithSameTitle: 'Zaten "{title}" ismi ile tanımlı bir süreç adımı bulunmaktadır.'
  },
  performanceList: {
    refresh: 'Yenile',
    createButtonText: 'Yeni',
    positionTypeId: 'Görev',
    roleTypeId: 'Rol',
    uomTypeName: 'Zaman Aralığı',
    editTemplate: 'Performans girişini değiştir',
    deleteTemplate: 'Performans girişini sil',
    errorPositionTypeLoad: 'Görev listesi yüklenemedi',
    errorRoleTypeLoad: 'Role listesi yüklenemedi',
    actives: 'Aktifler',
    archives: 'Arşivler',
    formTitle: 'Performans Hedefi',
    new: 'Yeni',
    edit: 'Düzenle',
    dateRangeEnd: 'Bitiş Tarihi',
    dateRangeStart: 'Başlangıç Tarihi',
    dateRange: 'Tarih Aralığı',
    title: 'Başlık',
    uomTypeIdPlaceholder: 'Zaman Aralığı Seçiniz',
    uomTypeId: 'Zaman Aralığı',
    positionTypeIdPlaceholder: 'Görev Seçiniz',
    positionTypeIdRequired: 'Görev seçilmelidir',
    uomTypeIdRequired: 'Zaman aralığı seçilmelidir',
    titleRequired: 'Başlık girilmelidir',
    endOfYear: 'Yıl Sonu',
    nextYear: 'Sonraki Yıl',
    dateRangeRequired: 'Zaman aralığı seçilmelidir',
    day1: 'Pazartesi',
    day2: 'Salı',
    day3: 'Çarşamba',
    day4: 'Perşembe',
    day5: 'Cuma',
    day6: 'Cumartesi',
    day7: 'Pazar',
    month1: 'Ocak',
    month2: 'Şubat',
    month3: 'Mart',
    month4: 'Nisan',
    month5: 'Mayıs',
    month6: 'Haziran',
    month7: 'Temmuz',
    month8: 'Ağustos',
    month9: 'Eylül',
    month10: 'Ekim',
    month11: 'Kasım',
    month12: 'Aralık',
    MONTHOFYEAR: 'Yılın Ayları',
    QUATEROFMONTH: 'Ayın dörtte biri',
    DAYSOFWEEK: 'Haftanın Günleri',
    total: 'Toplam'
  },
  timeSheet: {
    taskTitle: 'Görev',
    processTitle: 'Süreç',
    performanceReviewItemName: 'Performans Hedefi',
    uoMTitle: 'Dönem',
    estimatedValue: 'Hedef',
    actualValue: 'Değer',
    totalActualValueOfUom: 'Dönem İçi Toplam',
    fromDate: 'Başlangıç',
    thruDate: 'Bitiş',
    minute: 'Süre(Dakika)',
    comment: 'Açıklama',
    pickDay: 'Tarih Seçiniz',
    errorMessage: 'Yapılan işler okunamadı'
  },
  messageMapping: {
    eventName: 'Event',
    commandName: 'Command',
    actions: ' ',
    formtemplate: 'Event-Command Eşleşmesi',
    new: 'Yeni',
    edit: 'Düzenle',
    mappings: 'Eşleşme',
    messageName: 'Mesaj',
    property: 'Özellik',
    value: 'Değer'
  }
};